var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAiMagicWand = function SvgAiMagicWand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.834 11.666-2.5-2.5m4.175-6.25v-1.25m3.282 2.551.884-.884m-.884 7.5.884.884m-7.5-7.5-.883-.884m8.8 4.167h1.25M5.11 17.39l7.697-7.697c.33-.33.495-.495.557-.686a.835.835 0 0 0 0-.515c-.062-.19-.227-.355-.557-.685l-.614-.614c-.33-.33-.495-.495-.685-.557a.833.833 0 0 0-.515 0c-.19.062-.356.227-.686.557L2.61 14.89c-.33.33-.495.495-.557.686a.833.833 0 0 0 0 .515c.062.19.227.355.557.685l.614.614c.33.33.495.495.685.557a.833.833 0 0 0 .515 0c.19-.062.356-.227.686-.557Z",
    stroke: "url(#ai-magic-wand_svg__a)",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-magic-wand_svg__a",
    x1: 4.65,
    y1: 10.334,
    x2: 17.338,
    y2: 9.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4664FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#966BDB"
  })))));
};

export default SvgAiMagicWand;